import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import {Typography,TextField,withStyles,Button} from '@material-ui/core'
import { ModalHeader } from 'reactstrap';
import { checkPassWord,onUpdateUserPass } from 'actions';
import { useSelector,useDispatch } from 'react-redux';
import { isEmpty, isUndefined } from 'lodash';
import IntlMessages from 'util/IntlMessages';

const styles = (theme) => ({
    root: {
        padding: theme.spacing(2),
        margin: theme.spacing(4),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});
const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            
        </MuiDialogTitle>
    );
});
const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);
const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);
function UpdatePassWord(props) {
    const dispatch = useDispatch()
    const authUser = useSelector(state => state.auth.authUser)
    const isPassCompare = useSelector(state => state.auth.isPassCompare)
    const [currentPassword, setCurrentPassword] = React.useState('');
    const [newPassword, setNewPassword] = React.useState('');
    const [newPasswordError, setNewPasswordError] = React.useState('');
    const [newPasswordValidPass, setNewPasswordValidPass] = React.useState(true);
    const [confirmNewPassword, setConfirmNewPassword] = React.useState('');
    const [newPasswordCValidPass, setNewPasswordCValidPass] = React.useState(true);
    const [newPasswordCError, setnewPasswordCError] = React.useState('');

    const CheckPassword = ()=>{
       // dispatch(checkPassWord(authUser,authUser.user_id,currentPassword))
       const uppercaseRegExp   = /(?=.*?[A-Z])/;
       const lowercaseRegExp   = /(?=.*?[a-z])/;
       const digitsRegExp      = /(?=.*?[0-9])/;
       const specialCharRegExp = /(?=.*?[#?!@$%^&*-])/;
       const minLengthRegExp   = /.{8,}/;
       const passwordLength =      isUndefined(newPassword)?0:newPassword.length;
       const uppercasePassword =   isUndefined(newPassword)?false:uppercaseRegExp.test(newPassword);
       const lowercasePassword =   isUndefined(newPassword)?false:lowercaseRegExp.test(newPassword);
       const digitsPassword =      isUndefined(newPassword)?false:digitsRegExp.test(newPassword);
       const minLengthPassword =   isUndefined(newPassword)?false:minLengthRegExp.test(newPassword);
       const specialCharPassword =   isUndefined(newPassword)?false:specialCharRegExp.test(newPassword);
       let Error=<>
       {(passwordLength === 0 || !minLengthPassword)?<div style={{fontSize:10}}><IntlMessages id="Account.New.Password.Error.length" /></div>:""}
       {!uppercasePassword?<div style={{fontSize:10}}><IntlMessages id="Account.New.Password.Error.UpperCase" /></div>:""}
       {!lowercasePassword?<div style={{fontSize:10}}><IntlMessages id="Account.New.Password.Error.LowerCase" /></div>:""}
       {!digitsPassword?<div style={{fontSize:10}}><IntlMessages id="Account.New.Password.Error.Num" /></div>:""}
       {!specialCharPassword?<div style={{fontSize:10}}><IntlMessages id="Account.New.Password.Error.Special" /></div>:""}
       </>
       let isNot = (passwordLength === 0 || !minLengthPassword || !uppercasePassword || !lowercasePassword 
        ||!digitsPassword ||!specialCharPassword  )
        setNewPasswordError(isNot?Error:"")
        setNewPasswordValidPass(isNot?false:true)
    }

    const CheckPassword2 = ()=>{
       if(newPassword !== confirmNewPassword){
        setnewPasswordCError(<div style={{fontSize:10}}><IntlMessages id="Account.New.Password.Error.Notmatch" /></div>)
        setNewPasswordCValidPass(false)
       }else{
       // dispatch(checkPassWord(authUser,authUser.user_id,currentPassword))
       const uppercaseRegExp   = /(?=.*?[A-Z])/;
       const lowercaseRegExp   = /(?=.*?[a-z])/;
       const digitsRegExp      = /(?=.*?[0-9])/;
       const specialCharRegExp = /(?=.*?[#?!@$%^&*-])/;
       const minLengthRegExp   = /.{8,}/;
       const passwordLength =      isUndefined(confirmNewPassword)?0:confirmNewPassword.length;
       const uppercasePassword =   isUndefined(confirmNewPassword)?false:uppercaseRegExp.test(confirmNewPassword);
       const lowercasePassword =   isUndefined(confirmNewPassword)?false:lowercaseRegExp.test(confirmNewPassword);
       const digitsPassword =      isUndefined(confirmNewPassword)?false:digitsRegExp.test(confirmNewPassword);
       const minLengthPassword =   isUndefined(confirmNewPassword)?false:minLengthRegExp.test(confirmNewPassword);
       const specialCharPassword =   isUndefined(confirmNewPassword)?false:specialCharRegExp.test(confirmNewPassword);
       let Error=<>
       {(passwordLength === 0 || !minLengthPassword)?<div style={{fontSize:10}}><IntlMessages id="Account.New.Password.Error.length" /></div>:""}
       {!uppercasePassword?<div style={{fontSize:10}}><IntlMessages id="Account.New.Password.Error.UpperCase" /></div>:""}
       {!lowercasePassword?<div style={{fontSize:10}}><IntlMessages id="Account.New.Password.Error.LowerCase" /></div>:""}
       {!digitsPassword?<div style={{fontSize:10}}><IntlMessages id="Account.New.Password.Error.Num" /></div>:""}
       {!specialCharPassword?<div style={{fontSize:10}}><IntlMessages id="Account.New.Password.Error.Special" /></div>:""}
       </>
       let isNot = (passwordLength === 0 || !minLengthPassword || !uppercasePassword || !lowercasePassword 
        ||!digitsPassword ||!specialCharPassword  )
        setnewPasswordCError(isNot?Error:"")
        setNewPasswordCValidPass(isNot?false:true)
    }
    }
    const CheckPassword1 = ()=>{
        dispatch(checkPassWord(authUser,authUser.user_id,currentPassword))
    }
    const onUpdatePassword = ()=>{
        dispatch(onUpdateUserPass(authUser.user_id,currentPassword,newPassword))
    }
    return (
        <>
           <Dialog aria-labelledby="customized-dialog-title"
            open={true} fullWidth={true}
            disableBackdropClick={true}
            disableEscapeKeyDown={true}
            maxWidth={"xs"}>
                <ModalHeader className="modal-box-header bg-primary text-white">
                <IntlMessages id="PassWord.Save"/>
                </ModalHeader>
                <DialogContent dividers>
                <div className='my-2'>
                <TextField
                id="filled-password-input"
                label={<IntlMessages id="PassWord.Current" />}
                type="password"
                size="small"
                required
                error={isPassCompare === false ? true : false}
                fullWidth
                onChange={(e) => setCurrentPassword(e.target.value)}
                InputLabelProps={{ shrink: true }}
                variant="outlined"
                onBlur={CheckPassword1}
                autocomplete="off"
                helperText={<small> {isPassCompare === false?<div style={{fontSize:10}}>
                    <IntlMessages id="Account.New.Password.Error.inCorrect" />
                    </div>:""} </small>}
                />
                </div>
                <div className='my-2'>
                <TextField
                id="filled-password-input"
                label={<IntlMessages id="PassWord.New" />}
                type="password"
                size="small"
                error={newPasswordValidPass ? false : true}
                required
                fullWidth
                onChange={(e) => setNewPassword(e.target.value)}
                onBlur={CheckPassword}
                InputLabelProps={{ shrink: true }}
                variant="outlined"
                helperText={newPasswordError}
                autocomplete="off"
                />
                </div>
                <div className='my-2'>
                <TextField
                id="filled-password-input"
                label={<IntlMessages id="PassWord.New.confirm" />}
                type="password"
                size="small"
                required
                fullWidth
                onChange={(e) => setConfirmNewPassword(e.target.value)}
                InputLabelProps={{ shrink: true }}
                variant="outlined"
                onBlur={CheckPassword2}
                error={newPasswordCValidPass ? false : true}
                helperText={newPasswordCError}
                autocomplete="off"
                />
                </div>
                </DialogContent>
                <DialogActions>
                <div className="d-flex my-2 mx-2">
                    <div className="mr-auto">
                    <Button 
                    className="btn btn-link" 
                    color="primary"
                    disabled={isPassCompare === false && newPasswordValidPass === true && newPasswordCValidPass===true}
                    variant="contained"
                    onClick={onUpdatePassword}
                    >
                        <IntlMessages id="PassWord.Save" />
                    </Button>
                    </div>
                </div>
                
                </DialogActions>
            </Dialog> 
        </>
    );
}

export default UpdatePassWord;